module.exports = __webpack_public_path__ + "media/images/flags/it-86107e7f8423a2285392ff877b98aa1b.jpg";